"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JobTypeEnum = void 0;
var JobTypeEnum;
(function (JobTypeEnum) {
    JobTypeEnum["PLANNING"] = "planning";
    JobTypeEnum["PRECHECK"] = "precheck";
    JobTypeEnum["INSTALLATION"] = "installation";
    JobTypeEnum["ACTIVATION"] = "activation";
    JobTypeEnum["MAINTENANCE"] = "maintenance";
    JobTypeEnum["DEFECT_ELIMINATION"] = "defect_elimination";
    JobTypeEnum["METER_APPLICATION"] = "meter_application";
    JobTypeEnum["INSTALLATION_PREPARATION"] = "installation_preparation";
    JobTypeEnum["HARDWARE_SALE"] = "hardware_sale";
    JobTypeEnum["REMOTE"] = "remote";
    JobTypeEnum["RECLAMATION"] = "reclamation";
})(JobTypeEnum = exports.JobTypeEnum || (exports.JobTypeEnum = {}));
//# sourceMappingURL=job-type-enum.js.map